<div class="router-oulet-cont" [@routerTransition]>
    <div class="w-100">
        <app-title [title]="title" [icon]="icon"></app-title>
    </div>
    <div class="table-card">
        <div class="table-card-header mt-3">
            <div class="search-filter-wrapper">
                <div class="input-cont">
                    <i class="icon-btn fas fa-search" (click)="getDataPage(1)"></i>
                    <input type="text" class="input-txt" name="keyword" [placeholder]="'SearchWithThreeDot' | localize"
                        [(ngModel)]="keyword" (ngModelChange)="isKeywordClean(keyword)"
                        (keyup.enter)="getDataPage(1)" />
                </div>
                <div class="filter-flat" (click)="showFilters()">
                    <i class="material-icons-outlined">filter_list</i>
                    <span>{{ 'Filters' | localize }}</span>
                </div>
            </div>
            <div class="header-actions">
                <a href="javascript:;" class="btn-default btn-export"
                    (click)="saveUserPreferences()"
                    [tooltip]="'SaveTablePreferences' | localize">
                    <i class="fa fa-save"></i>
                </a>
                <button class="btn-default"
                    (click)="createItem()">
                    {{ "Create" | localize }}
                    <i [ngClass]="styles.ButtonIcon" class="fa-plus-circle"></i>
                </button>
            </div>

            <div *ngIf="showingFilters" class="dynamic-filters-container general-info-cont form-grid">
                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <input type="text" class="input-txt truncate-multiselect"
                        name="executionDateRange" autocomplete="off"
                        bsDaterangepicker
                        [minDate]="minDate" [maxDate]="maxDate"
                        [bsConfig]="{ dateInputFormat: getDateInputFormat(), displayOneMonthRange: true }"
                        [(ngModel)]="executionDateRange"
                        [placeholder]="'SelectNextRun' | localize"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onDateRangeSelected($event)"
                        (keydown.enter)="onDateRangeEnter()" />
                        <i class="fa-regular fa-calendar calendar-icon"></i>
                    </div>
                </div>

                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <p-multiSelect class="input-txt truncate-multiselect"
                        [options]="recipientOptions"
                        [(ngModel)]="reminderFilters.recipientIds"
                        optionLabel="name" optionValue="id"
                        [placeholder]="'SelectRemindTo' | localize"
                        [selectedItemsLabel]="l('SelectedItemsLabel')"
                        [filter]="true"
                        (onChange)="onFilterChange()"
                        [emptyMessage]="'NoResultsFound' | localize"
                        [emptyFilterMessage]="'NoResultsFound' | localize">
                        </p-multiSelect>
                    </div>
                </div>

                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <div class="custom-dropdown-container" #entityDropdownRef>
                            <div class="custom-dropdown-header" (click)="showEntityDropdown = !showEntityDropdown">
                                {{ getSelectedEntitiesLabel() || ('SelectLinkedTo' | localize) }}
                                <i class="pi" [ngClass]="showEntityDropdown ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                            </div>
                            <div class="custom-dropdown-panel" *ngIf="showEntityDropdown">
                                <div class="search-bar">
                                    <input
                                    type="text"
                                    [(ngModel)]="searchTerm"
                                    (input)="onSearchTermChange()"
                                    placeholder="{{ 'Search' | localize }}"
                                    />
                                </div>
                                <div *ngFor="let group of filteredEntities" class="group-section">
                                    <div class="group-header" (click)="group.expanded = !group.expanded">
                                    <div class="group-checkbox-wrapper" (click)="$event.stopPropagation()">
                                        <input
                                        type="checkbox"
                                        [checked]="isGroupFullySelected(group)"
                                        [disabled]="group.items.length === 0"
                                        (change)="toggleGroupSelection(group, $event.target.checked)" />
                                    </div>
                                    <span class="group-label">{{ group.label }}</span>
                                    <i
                                        class="pi float-right"
                                        [ngClass]="group.expanded ? 'pi-chevron-down' : 'pi-chevron-right'"
                                        (click)="toggleGroup(group); $event.stopPropagation()"
                                    ></i>
                                    </div>
                                    <div class="group-items" *ngIf="group.expanded">
                                        <div *ngFor="let item of group.items" class="item-checkbox">
                                        <p-checkbox
                                            [label]="item.name"
                                            [binary]="true"
                                            [ngModel]="isEntitySelected(item.id)"
                                            (onChange)="toggleEntitySelection(item.id)">
                                        </p-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <p-multiSelect class="input-txt truncate-multiselect"
                        [options]="typeOptions"
                        [(ngModel)]="reminderFilters.typeIds"
                        optionLabel="name" optionValue="id"
                        [placeholder]="'SelectTypes' | localize"
                        [selectedItemsLabel]="l('SelectedItemsLabel')"
                        [filter]="true"
                        (onChange)="onFilterChange()"
                        [emptyMessage]="'NoResultsFound' | localize"
                        [emptyFilterMessage]="'NoResultsFound' | localize">
                        </p-multiSelect>
                    </div>
                </div>

                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <p-multiSelect class="input-txt truncate-multiselect"
                        [options]="priorityOptions"
                        [(ngModel)]="reminderFilters.priorityIds"
                        optionLabel="name" optionValue="id"
                        [placeholder]="'SelectPriorities' | localize"
                        [selectedItemsLabel]="l('SelectedItemsLabel')"
                        [filter]="true"
                        (onChange)="onFilterChange()"
                        [emptyMessage]="'NoResultsFound' | localize"
                        [emptyFilterMessage]="'NoResultsFound' | localize">
                        </p-multiSelect>
                    </div>
                </div>

                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <p-multiSelect class="input-txt truncate-multiselect"
                        [options]="stateOptions"
                        [(ngModel)]="reminderFilters.stateValues"
                        [placeholder]="'SelectStates' | localize"
                        [selectedItemsLabel]="l('SelectedItemsLabel')"
                        [filter]="true"
                        (onChange)="onFilterChange()"
                        [emptyMessage]="'NoResultsFound' | localize"
                        [emptyFilterMessage]="'NoResultsFound' | localize">
                        </p-multiSelect>
                    </div>
                </div>

                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <p-multiSelect class="input-txt truncate-multiselect"
                            [options]="creatorUserOptions"
                            [(ngModel)]="reminderFilters.creatorUserIds"
                            optionLabel="name" optionValue="id"
                            [placeholder]="'SelectCreatorUsers' | localize"
                            [selectedItemsLabel]="'ItemsSelected{0}' | localize"
                            (onChange)="onFilterChange()"
                            [filter]="true"
                            [style]="{ width: '100%' }"
                            [emptyMessage]="'NoResultsFound' | localize"
                            [emptyFilterMessage]="'NoResultsFound' | localize">
                        </p-multiSelect>
                    </div>
                </div>

                <div class="input-label-cont extra form-grid-item">
                    <div class="input-cont icon-addon">
                        <input type="text"
                            class="input-txt truncate-multiselect"
                            bsDaterangepicker
                            [(ngModel)]="reminderFilters.creationDateRange"
                            (ngModelChange)="onFilterChange()"
                            [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', displayOneMonthRange: true }"
                            [minDate]="minDate"
                            [maxDate]="maxDate"
                            [placeholder]="'PeriodCreation' | localize"
                            autocomplete="off" />
                        <i class="fa-regular fa-calendar calendar-icon"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-card-body fixed-height-persons">

            <p-table
                [value]="reminderList"
                [resizableColumns]="true"
                [reorderableColumns]="true"
                [scrollable]="true"
                scrollHeight="flex"
                [rows]="pageSize"
                [paginator]="false"
                [totalRecords]="totalItems"
                [lazy]="true"
                [loading]="loading"
                (onLazyLoad)="getDataPage($event)"
                [rowsPerPageOptions]="[5, 10, 20, 50]"
                [customSort]="true"
                (sortFunction)="onSort($event)"
                class="custom-table">

                <!-- Cabecera -->
                <ng-template pTemplate="header">
                    <tr cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="onColumnDrop($event)">
                        <th class="aux-col"></th>
                        <ng-container *ngFor="let col of visibleColumns; let last = last">
                        <th
                        pResizableColumn
                        [pSortableColumn]="col.field"
                        cdkDrag
                        [cdkDragDisabled]="isResizing"
                        [ngClass]="{ 'before-actions-col': last }">
                        {{ col.header | localize }}
                        <i *ngIf="orderField === col.field" class="pi"
                            [ngClass]="{
                            'pi-sort-up': orderDirection === 1,
                            'pi-sort-down': orderDirection === -1
                            }"
                            style="margin-left: 6px; font-size: 0.8rem;"></i>
                        </th>
                        </ng-container>
                        <th class="actions-col">
                            <button #menuAnchor pButton type="button" icon="pi pi-cog" class="gear-btn"
                                (click)="columnOverlay.toggle($event)">
                            </button>
                            <p-overlayPanel #columnOverlay [dismissable]="true" appendTo="body">
                                <div class="column-menu">
                                <div *ngFor="let col of columns" class="column-toggle-item" (click)="toggleColumn(col)">
                                    <span class="pi" [ngClass]="col.visible ? 'pi-check-square' : 'pi-square'"></span>
                                    <label class="ms-2">{{ col.header | localize }}</label>
                                </div>
                                </div>
                            </p-overlayPanel>
                        </th>
                    </tr>
                    </ng-template>

                <!-- Cuerpo -->
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td></td>
                        <td *ngFor="let col of visibleColumns">
                            <ng-container [ngSwitch]="col.field">
                                <span *ngSwitchCase="'nextExecution'">
                                    <ng-container *ngIf="!isNextExecutionUndefined(item)">
                                        {{ getNextExecution(item) }}
                                    </ng-container>
                                    <ng-container *ngIf="isNextExecutionUndefined(item)">
                                        <span style="color: gray;">{{ getNextExecution(item) }}</span>
                                    </ng-container>
                                </span>
                                <span *ngSwitchCase="'recipient'">
                                    <ng-container *ngIf="item.reminderRecipients.length === 1">
                                        {{ item.reminderRecipients[0].user.fullName }}
                                    </ng-container>
                                    <ng-container *ngIf="item.reminderRecipients.length > 1"
                                        [pTooltip]="getRecipientsText(item)">
                                        {{ getRecipientsText(item) }}
                                    </ng-container>
                                </span>
                                <span *ngSwitchCase="'linkedTo'">
                                {{
                                    item.company
                                        ? item.company.name + ' ' + item.company.companyTypeCode + ''
                                        : item.juridicalPerson
                                            ? item.juridicalPerson.name + ' ' + item.juridicalPerson.companyTypeCode + ''
                                            : item.naturalPerson
                                                ? item.naturalPerson.names + ' ' + item.naturalPerson.surnames
                                                : ''
                                }}
                                </span>
                                <span *ngSwitchCase="'type'">
                                    {{ item.reminderType?.name }}
                                </span>
                                <span *ngSwitchCase="'priority'">
                                    {{ item.reminderPriority?.name }}
                                </span>
                                <span *ngSwitchCase="'description'" class="description-cell"
                                    [innerHTML]="truncateHtmlWithFormat(item['description'], 150)"
                                    pTooltip="{{ formatTooltipWithLineBreaks(item['description']) }}"
                                    tooltipClass="custom-description-tooltip"
                                    [escape]="false">
                                </span>
                                <span *ngSwitchCase="'state'">
                                    {{ getNotificationState(item) }}
                                </span>
                                <span *ngSwitchCase="'creatorUserName'">
                                    {{ item.creatorUserName || '-' }}
                                </span>
                                <span *ngSwitchCase="'creationTime'">
                                    {{ item.creationTime | date: 'dd/MM/yyyy HH:mm' }}
                                </span>
                                <span *ngSwitchDefault>
                                    {{ item[col.field] }}
                                </span>
                            </ng-container>
                        </td>
                        <td class="buttons-container center actions-col">
                            <button *ngIf="getNotificationState(item) != ('Completed' | localize)" type="button" class="btn-row" [pTooltip]="'Edit' | localize"
                                (click)="editItem(item)">
                                <i class="material-icons-outlined">edit</i>
                            </button>
                            <button type="button" class="btn-row red" [pTooltip]="'Delete' | localize"
                                (click)="delete(item)">
                                <i class="material-icons-outlined">delete</i>
                            </button>
                        </td>
                    </tr>
                </ng-template>

                <!-- Mensaje vacío -->
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="visibleColumns.length + 1" class="text-center">
                            {{ 'NoInfoRecorded' | localize }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="table-card-footer paginator-footer">
            <button class="btn-row" (click)="refresh()">
                <i class="material-icons-outlined">refresh</i>
            </button>
            <p class="mb-0 my-2">
                {{ "TotalRecordsCount" | localize : totalItems }}
            </p>
            <p-paginator
                [rows]="pageSize"
                [totalRecords]="totalItems"
                [showFirstLastIcon]="true"
                [first]="(pageNumber - 1) * pageSize"
                (onPageChange)="getDataPage($event)">
            </p-paginator>
        </div>
    </div>
</div>